export const qrcode = {
  code: null,
  width: 300,
  height: 300,
  logoUrl: 'https://s3.us-east-1.amazonaws.com/igotu_prod/v2/mail/logo_trasparent.png'

}
